var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"promocion-se"},[_c('div',{staticClass:"overflow-auto background-images"},[_c('Container',{attrs:{"title":_vm.title,"menu":_vm.menu,"theme":_vm.theme}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }